import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27f652f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-clipboard me-2" }),
    /*#__PURE__*/_createTextVNode("บันทึกการปฏิบัติงาน")
  ]),
  /*#__PURE__*/_createElementVNode("h6", { class: "card-subtitle text-muted" }, "รายงานบันทึกการปฏิบัติงาน")
], -1))
const _hoisted_3 = { class: "card-body my-3" }
const _hoisted_4 = { class: "table-responsive" }
const _hoisted_5 = {
  ref: "datatable",
  class: "table table-hover"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "#"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "กิจกรรม"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "วันที่"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ตาราง"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ข้อมูล")
  ])
], -1))
const _hoisted_7 = ["data-bs-content"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mementos, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: "row-hover"
              }, [
                _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                _createElementVNode("td", {
                  class: _normalizeClass({'text-success': item.actionName == 'เพิ่ม', 'text-warning': item.actionName == 'แก้ไข', 'text-danger': item.actionName == 'ลบ'})
                }, _toDisplayString(item.actionName), 3),
                _createElementVNode("td", null, _toDisplayString(_ctx.thaiDate(item.createdAt)), 1),
                _createElementVNode("td", null, _toDisplayString(item.type), 1),
                _createElementVNode("td", {
                  "data-bs-toggle": "popover-project",
                  "data-bs-content": item.serializedData
                }, " ดูข้อมูล ", 8, _hoisted_7)
              ]))
            }), 128))
          ])
        ], 512)
      ])
    ])
  ]))
}